import React from 'react';
import styles from './Card.module.scss';
import clsx from 'clsx';

export const Card = ({ children, className, variant, interactive, ...props }) => (
    <div data-ds-theme={variant === 'inverse' ? 'dark' : undefined}
        className={clsx(
            styles.card,
            variant && styles[`card--${variant}`],
            interactive && styles['card--interactive'],
            className
        )}
        {...props}
    >
        {children}
    </div>
);

export const CardHeader = ({ children, className, ...props }) => (
    <div className={clsx(styles.card__header, className)} {...props}>
        {children}
    </div>
);

export const CardTitle = ({ children, className, as: Heading = 'h3', ...props }) => (
    <Heading className={clsx(styles.card__title, className)} {...props}>
        {children}
    </Heading>
);

export const CardDescription = ({ children, className, ...props }) => (
    <p className={clsx(styles.card__description, className)} {...props}>
        {children}
    </p>
);

export const CardContent = ({ children, className, ...props }) => (
    <div className={clsx(styles.card__content, className)} {...props}>
        {children}
    </div>
);
